import { Injectable } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { User } from '../_models';
import { Role } from '../_models/role';

@Injectable()
export class AuthService {

    private CustomerRoutes: string[] = ["my-tickets","TicketDetail","CreateTickets","overDueTickets"];
    private CSPUserRoutes: string[] = ["my-tickets","TicketDetail","CreateTickets","overDueTickets","customers","all-tickets"];
    private LayoutMenus: any[] = [];
    cUser:User =  JSON.parse(localStorage.getItem('currentUser'));
    
    constructor(private router: Router,        
        private activatedRoute: ActivatedRoute){

            
    }

    public isRouteAuthorized(url: string): boolean {
   
        let valid = true;

        // if(this.cUser.roles == Role.Customer){
        //     let index = this.CustomerRoutes != null && this.CustomerRoutes.length > 0 ?  this.CustomerRoutes.findIndex(u => url.indexOf(u.split(":")[0]) != -1) : -1;
        //     if (index == -1) valid = false;
        // }
        // else if(this.cUser.roles == Role.CSP){
        //     let index = this.CSPUserRoutes != null && this.CSPUserRoutes.length > 0 ?  this.CSPUserRoutes.findIndex(u => url.indexOf(u.split(":")[0]) != -1) : -1;
        //     if (index == -1) valid = false;
        // }
        // else{
        //     valid = true;
        // }

        return valid;
    }
}